const UserRole = {
  "admin@sinisana.net": ["SUPERUSER"],
  "superadmin@neocrab.com": ["SUPERUSER"],
  "customer@sinisana.net": ["CUSTOMER.ADMIN"],
  "manufacturer@sinisana.net": ["MANUFACTURER.ADMIN"],
};

export default UserRole;
